import apiClient from './client';

export const agentAPI = {
  // Get bridge health (no auth on agent side, but PCC auth required)
  getHealth: async () => {
    const response = await apiClient.get('/me/agent/health');
    return response.data;
  },

  // Get bridge status with version and uptime
  getStatus: async () => {
    const response = await apiClient.get('/me/agent/status');
    return response.data;
  },

  // Get system info (CPU, memory, disk, uptime)
  getSystemInfo: async () => {
    const response = await apiClient.get('/me/agent/system');
    return response.data;
  },

  // Get list of containers
  getContainers: async () => {
    const response = await apiClient.get('/me/agent/containers');
    return response.data;
  },

  // Get container logs
  getContainerLogs: async (containerName, lines = 100) => {
    const response = await apiClient.get(`/me/agent/containers/${containerName}/logs`, {
      params: { lines },
    });
    return response.data;
  },
};
